var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:{ fs: _vm.fullsize }},[_c('ul',{staticClass:"spinner"},_vm._l((12),function(n){return _c('li',{key:n})}),0),_c('p',{staticClass:"font-size-md font-weight-bold mt-3"},[_vm._v(" Please do not shut down your browser. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }